<script>
  import {onMount, createEventDispatcher, tick} from 'svelte'

  export let width
  export let height
  export let id
  
  const dispatch = createEventDispatcher()

  if(width === undefined || width <= 0) width = 100
  if(height === undefined || height <= 0) height = 100

  const houseWidth = 32
  const houseHeight = 30
  const scale = 0.75
  const houseScale = 1.66

  $: aspectRatio = (width/height)
  $: tileWidth = houseWidth * houseScale
  $: tileHeight = houseHeight * houseScale
  
  $: cols = Math.ceil(width / tileWidth)
  $: rows = Math.ceil(height / tileHeight)
  $: fillWidth = (100 / cols).toFixed(3)
  $: fillHeight = (fillWidth * aspectRatio).toFixed(3)
  $: offsetX = ((cols * tileWidth) - width) / 2
  $: offsetY = ((rows * tileHeight) - height)
  $: if(width) {
    tick().then(() => {
      dispatch('redraw', true)
    })
  }

</script>

<svg {id} width={width} height={height} viewBox="0 0 {width} {height}" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <symbol id="house-single" viewBox="0 0 {houseWidth} {houseHeight}">
      <path fill="currentColor" transform="translate({(1 - scale) * houseWidth/2}, {(1 - scale) * houseHeight/2}) scale({scale})" d="M16.1724 0L2.55176 11.3333V30H29.7931V11.3333L16.1724 0ZM27.8966 28.1667H4.44831V12.1667L16.1724 2.5L27.8966 12.1667V28.1667Z" />
    </symbol>
  </defs>
  {#each Array(rows) as row, i}
    <g class="row">
      {#each Array(cols) as house, j}
        <svg class="house" id="house-tile_{i}-{j}" x="{j * tileWidth - offsetX}" y="{ i * tileHeight - offsetY}" width="{tileWidth}" height="{tileHeight}"><use xlink:href="#house-single" /></svg>
      {/each}
    </g>
  {/each}
</svg>
